export const PKG_NAME = "@hpcc-js/common";
export const PKG_VERSION = "2.66.1";
export const BUILD_VERSION = "2.102.2";
